module.exports = __webpack_public_path__ + "img/frame (149).2ddf0237.jpg";